import 'stylings/global.styles.scss';
import '@sanlam-glacier/app-common/cx/override';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import App from './App';

const element = document.getElementById('app');

const root = createRoot(element as Element);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
